<template>
  <div class="tracking row justify-center">
    <TileBar
      v-if="$q.screen.gt.xs"
      option-button="Back"
      @on-button="$router.go(-1)"
    />
  </div>
</template>

<script>
export default {
  name: "OrderTracking",
  components: {
    TileBar: () => import("@/ui/components/TileBar.vue"),
  },
};
</script>

<style>

</style>
